<div id="toggler" class="d-flex py-2" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-3">
        <span>{{ material.materialNr.value }}</span
        ><br />
        <span>{{ material.descTxt }}</span
        ><br />
        <span *ngIf="displayMaterialNotAvailable(material)" translate="MATERIAL_AVAILABILITY_MATERIAL_NOT_FOUND"></span>
    </div>
    <div class="col-3">
        <span>{{ material.storageLoc.value }}</span
        ><br />
        <span>{{ material.storageLocDesc }}</span>
    </div>
    <div class="col-3">
        <span>{{ material.available }}</span>
        <span>&nbsp;</span>
        <span>{{ material.extUnit }}</span>
    </div>
    <div class="col-1">
        <span *ngIf="showMaterialPricingInfo">{{ material.customerPrice | localCurrency }}</span>
    </div>
</div>
<div *ngIf="!isCollapsed">
    <div class="row justify-content-center">
        <div class="col-6">
            <ul class="list-unstyled d-flex flex-column align-items-center">
                <li>
                    <ng-container *ngIf="material.longText.length > 0">
                        <span *ngFor="let line of material.longText">
                            <div *ngFor="let part of line.split(';')" class="mb-3">
                                <ng-container *ngIf="part.includes(':')">
                                    <span class="col-form-label">{{ part.split(':')[0] }}:</span>
                                    {{ part.split(':')[1].trim() ? part.split(':')[1] : 'xxxxx' }}
                                </ng-container>
                                <ng-container *ngIf="!part.includes(':')">
                                    {{ part.trim() ? part : 'XXXXXX' }}
                                </ng-container>
                            </div>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="showMaterialTSInfo">
                        <div class="mb-1">
                            <label class="col-form-label" translate="MATERIAL_AVAILABILITY_LABEL_TS"></label>
                            {{ material.tsPercentage }}%/{{ material.tsPercentageCounter }}
                        </div>
                        <div *ngIf="showMaterialNDFInfo" class="mb-1">
                            <label class="col-form-label" translate="MATERIAL_AVAILABILITY_LABEL_NDF"></label>
                            {{ material.ndfQuote }}%/{{ material.ndfCounter }}
                        </div>
                    </ng-container>
                </li>
            </ul>
        </div>
    </div>
</div>
